module.exports = __webpack_public_path__ + "img/shiba-head-level4.870aa7ac.png";